import Promise from "bluebird";

// Default crop data
const defaultCrop = {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
};

export default function ImageToPng(image, crop = defaultCrop) {
    return new Promise((resolve) => {
        // Get image dimensions
        const imageWidth = image.naturalWidth;
        const imageHeight = image.naturalHeight;
        const cropX = (crop.x / 100) * imageWidth;
        const cropY = (crop.y / 100) * imageHeight;
        const cropWidth = (crop.width / 100) * imageWidth;
        const cropHeight = (crop.height / 100) * imageHeight;

        // Create canvas
        const canvas = document.createElement("canvas");
        canvas.width = cropWidth;
        canvas.height = cropHeight;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(image, cropX, cropY, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);

        canvas.toBlob(resolve, "image/png");
    }).then((blob) => ({
        encoded: blob,
        preview: URL.createObjectURL(blob),
        size: blob.size,
        type: blob.type,
        cropped: crop === defaultCrop ? "original" : "cropped",
    }));
}
